import * as yup from 'yup'
import { TypesCoupon } from '../api/coupons/coupons'

const now = new Date()
const oneYearLater = new Date(now.getTime())
oneYearLater.setFullYear(oneYearLater.getFullYear() + 1)

const typeValues = Object.values(TypesCoupon)

export const couponsSchema = yup.object({
	type: yup
		.mixed<TypesCoupon>()
		.oneOf(typeValues, 'Tipo inválido')
		.required('EL tipo de requerido'),

	discount: yup
		.number()
		.min(5, 'El valor mínimo debe ser 5%')
		.max(100, 'El valor máximo es 100%')
		.optional(),

	expiration: yup
		.string()
		.required('Debes seleccionar fecha y hora')
		.matches(
			/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/,
			'El formato debe ser YYYY-MM-DDTHH:mm'
		)
		.test(
			'is-valid',
			'Fecha inválida',
			(value) => !!value && !isNaN(new Date(value).getTime())
		)
		.test(
			'not-in-past',
			'La fecha no puede ser anterior al momento actual',
			(value) => !!value && new Date(value) >= now
		)
		.test(
			'not-too-far',
			'La fecha no puede exceder un año desde hoy',
			(value) => !!value && new Date(value) <= oneYearLater
		),
})
